
export default {
  name: 'VsTableLabel',
  inheritAttrs: false,
  inject: ['table'],
  props: {
    label: {
      type: String,
      default: null
    },
    options: {
      type: Object,
      default: () => ({})
    }
  }
}
